module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/babel-runtime/core-js/object/define-property.js
 ** module id = 2
 ** module chunks = 0 1
 **/